<template>
    <div class="alarm-form__details">
        <div class="row-wrapper">
            <div class="input-wrapper">
                <label for="" class="alarm-form__label"> Event Type </label>
                <v-select
                    v-model="alarmProcessed.eventType"
                    :items="getEventTypes"
                    class="small-field"
                    :rules="rules.eventType"
                    label="Select event type"
                    item-text="key"
                    item-value="id"
                    outline
                    single-line
                ></v-select>
            </div>
            <div class="input-wrapper">
                <label for="" class="alarm-form__label"> Event Classification </label>
                <v-select
                    v-model="alarmProcessed.eventClassification"
                    :items="filteredEventClassifications"
                    :rules="rules.eventClassification"
                    class="small-field"
                    label="Select event classification"
                    item-text="key"
                    item-value="id"
                    outline
                    single-line
                ></v-select>
            </div>
        </div>
        <div class="input-wrapper">
            <label for="" class="alarm-form__label"> Channels </label>
            <v-select
                v-model="alarmProcessed.channels"
                label="Select channels"
                class="small-field"
                :items="availableChannels"
                :rules="rules.channels"
                item-text="key"
                item-value="id"
                multiple
                outline
                single-line
            ></v-select>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'RaiseEvent',
    inject: ['availableChannels'],
    mounted () {
    },
    props: {
        alarmProcessed: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getEventClassifications: 'dictionaryModule/getEventClassifications',
            getEventTypes: 'dictionaryModule/getEventTypes'
        }),
        filteredEventClassifications () {
            return this.getEventClassifications.filter(event => {
                return 1 < event.id
            })
        }
    },
    data () {
        return {
            rules: {
                eventType: [
                    v => 0 <= v || 'You have to specify event type'
                ],
                eventClassification: [
                    v => 0 < v || 'You have to specify event classification'
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
